export default "__VITE_ASSET__BBIGZ$dA__"